import "./Main.css";
import React, { useEffect, useState } from "react";
import { Auth, Storage } from "aws-amplify";
import { Box, Grommet, ResponsiveContext, Text } from "grommet";
import Sidebar from "./sidebar/Sidebar";
import Body from "./body/Body";
import { Link, BrowserRouter as Router, useLocation, useNavigate, useParams } from "react-router-dom";
import { useErrorHandler } from "./body/common/context/ErrorStore";
import ErrorDialog from "./body/common/error-dialog/ErrorDialog";
import { NotificationToast } from "./body/common/notification-toast/NotificationToast";
import StandardColors from "../../util/StandardColors";
import SpinnerLoader from "./body/common/spinner/SpinnerLoader";
import { useUser } from "./context/User/UserContext";
import Header from "./header/Header";
import { useSidebar } from "./context/Sidebar/SidebarContext";
import AsyncStorage from "@react-native-community/async-storage";
import { EndpointService } from "../../services/endpoint/endpoint.service";
import { useInAppNotification } from "./context/InAppNotificationContext/InAppNotificationContext";
import { NotificationAlert } from "./body/common/notification-toast/NotificationAlert";
import updatelastseen from "./UpdateLastSeen";
import { FlightService } from "../../services/flights/flight.service";
import { useNewEmergency } from "./context/MedicalListContext/MedicalListContext";
import { useReport } from "./context/IndicatorContext/IndicatorContext";
import notificationSound from '../../Audio/notificationSound.mp3';
import { useStore } from "../../Hooks/useStore";
import { observer } from "mobx-react";
import { generateDeviceId, loadStateFromStorage, saveDeviceToken, saveStateToStorage } from "../../util/CheckMultiLogin/CheckMultiLogin";
import usersService from "./body/screens/IAM/Users/users.service";
import logoutIcon from '../../assets/log-out.png';
import skali_logo from '../../assets/header-skali-logo.svg';
import notificationMessage from '../../assets/notification-message-image.png';
import chatNotification from '../../assets/chatIcon.png';
import profile from '../../assets/profile.webp';
import activeBell from '../../assets/active-bell.png';
import inActiveBell from '../../assets/inactive-bell.png';
import crown from '../../assets/crown.png';
import { Mixpanel } from "../../util/Helper";
import { SuccessMsg } from "./body/common/SuccessMsg/SucessMsg";
import { unsubscribeToTopic } from "../../App";
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { handleVideoNotificationClick } from "./VideoOnNotification/VideoCallOnNotification";
import MedicalEmergencyService from "../../services/medical-emergency/medical-emergency.service";
import Utility from "../../util/api/Utility";
import createuserService from "./body/screens/IAM/Users/CreateUser/createuser.service";
import { CallNotification } from "./body/common/SuccessMsg/CallNotification/CallNotification";
import AnalogClock from './AnalogClock'; // Import the AnalogClock component
import './AnalogClock.css'; // Make sure to import the CSS
import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";

const Main = observer((props) => {
  const navigate = useNavigate();
  const { rootStore } = useStore();
  const location = useLocation();
  const [location1, setLocation1] = useState('');
  const [orgId, setOrgId] = useState(null);
  const { show, text, showInAppNotification, hide } = useInAppNotification();
  const [subscription, setSubscription] = useState(null);
  const [subscriptionError, setSubscriptionError] = useState(false);
  const { newEmergencyNotification, handleNewEmergencyNotification } = useNewEmergency();

  const { report, handleNewReportNotification } = useReport();
  const [temperature, setTemperature] = useState('');
  const { user, setUser } = useUser();
  const { showSidebar } = useSidebar();
  const [localTime, setLocalTime] = useState('');
  const { pathname } = location;

  const apiKey = '4318003be7410a5364053e3936854c9c';

  // Set device token if not store
  const checkDeviceToken = async (username) => {
    let storedDevice = await usersService.getDeviceToken(username);
    let generateDevoceToken = await generateDeviceId();
    if (storedDevice.deviceToken == null || storedDevice.deviceToken != generateDevoceToken) {
      await saveDeviceToken();
    }
  }


   //// get local time
   useEffect(() => {
    const updateLocalTime = () => {
      const currentDate = new Date();
      const localTimeString = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      }).format(currentDate);
      setLocalTime(localTimeString);
    };

    updateLocalTime();
    const timeInterval = setInterval(updateLocalTime, 1000); // Update time every second

    return () => clearInterval(timeInterval); // Cleanup interval on component unmount
  }, []);

  useEffect(() => {
    // Function to fetch the user's location and weather data
    const fetchWeatherData = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const { latitude, longitude } = position.coords;
          setLocation1({ latitude, longitude });

          // Fetch weather data from OpenWeatherMap API
          const weatherResponse = await fetch(
            `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=imperial`
          );
          const weatherData = await weatherResponse.json();
          setTemperature(weatherData.main.temp.toFixed(1)); // Get the temperature in Celsius
        });
      } else {
        console.error('Geolocation is not supported by this browser.');
      }
    };

    // Fetch weather data immediately when the component mounts
    fetchWeatherData();

    // Set an interval to fetch the weather data every 1 minute (60000 ms)
    const intervalId = setInterval(fetchWeatherData, 60000);

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  const [imageSrc, setImageSrc] = useState(rootStore.userStore.getProfileUrl);
  useEffect(() => {
    setImageSrc(rootStore.userStore.getProfileUrl);
  }, [rootStore.userStore.getProfileUrl])
  const getImage = async (filePath) => {
    try {
      const fileUrl = await Storage.get(filePath, {
        bucket: 'sbx-skali-report',
        region: 'us-west-1',
        level: 'public', // Adjust access level if needed
        expires: 604799
      });

      const response = await fetch(fileUrl);

      if (response.ok && response.headers.get('Content-Type')?.startsWith('image/')) {
        // If it's an image, set the image source
        // setImageSrc(fileUrl); // Only set if it's a valid image
        rootStore.userStore.setProfileUrl(fileUrl)
        setImageSrc(fileUrl)
        const messageContent = fileUrl.split('?')[0];
        return messageContent;
      } else {
        console.error('No valid image found at the URL:', fileUrl);
        return null; // Return null or handle the case where the image does not exist
      }
    } catch (error) {
      console.error('Error fetching image:', error);
      return null; // Return null or handle the error gracefully
    }
  };

  useEffect(() => {
    // console.log("tttt");
    // Auth.currentSession().then((sess) => {
    //   console.log("accesstoken: ", sess.getAccessToken().getJwtToken());
    // });
    if (user && user != null) {
      // Auth.currentUserInfo().then((data) => {
      //   const user = {
      //     username: data.username,
      //     ...data.attributes,
      //   };
      //   setUser(user);
      //   rootStore.emsStore.handleUser(user);
      // checkDeviceToken(user.username);
      const img = getImage(`profilePhotos/${user.username}/profile.png`);
      if (user["custom:type"] == "crew") {
        setInterval(async () => {
          let flights = FlightService.listFlights();
          (await flights).map(async (flight) => {
            let flightId = await flight.id;
            updatelastseen(flightId);
          });
        }, 60000);
      }
      // checkEndpointValue();
      // let a = localStorage.getItem("isUrlRegister");
      // console.log("aaaaa",a);
      // if ( a !== "yes" ) {
      // registerEndpoint()
      //   .then((r) => {
      //     console.log("rr",r);
      //     console.log("registered endpoint successfully");
      //     localStorage.setItem("isUrlRegister","yes");
      //   })
      //   .catch(error => {
      //     console.log("registerApiError",error);
      //   });
      // }
      // });
    } else {
      let uInfo = localStorage.getItem("userinfo");
      const userinformation = JSON.parse(uInfo);
      setUser(userinformation);
    }
  }, [user]);

  const onChatNotificationClick = (incidentId) => {
    const navigationPath = "ems/medical-emergencies/emergency/" + incidentId;
    navigate(navigationPath);
  }

  useEffect(() => {
    const channel = new BroadcastChannel("my-channel");
    channel.addEventListener("message", (event) => {
      console.log("Received message:", event?.data);
      console.log("notification type of", typeof (event?.data?.type));
      if (event?.data?.type === "message-from-sw") {
        const { title, message, additionalKeyset, flightId } = event?.data?.data;
        if (pathname.indexOf("/call") == -1) {
          NotificationManager.success(message, title, 6000, () => {
            if (title.toLowerCase().includes("joined videocall")) {
              handleVideoNotificationClick(title, additionalKeyset, flightId, getMedical, rootStore);
            } else if (title.toLowerCase().includes("chat notification" || additionalKeyset != "" || additionalKeyset != null)) {
              onChatNotificationClick(additionalKeyset);
            } else {

            }
          }, true);
        }
        console.log('title + ";" + message', title + ";" + message);
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        const existingData = localStorage.getItem('notificationlist');

        let newItem = {
          time: timestamp,
          title: title,
          message: message,
          eventId: additionalKeyset ?? "",
          flightId: flightId ?? ""
        }

        // Step 2: Parse existing data into an array (or initialize as empty array if null)
        let dataArray = existingData ? JSON.parse(existingData) : [];

        // Step 3: Push the new item into the array
        dataArray.unshift(newItem);
        // alert(dataArray[0])

        // Step 4: Convert the updated array back to JSON string
        const updatedData = JSON.stringify(dataArray);
        // Step 5: Save the updated JSON string back to localStorage
        localStorage.setItem('notificationlist', updatedData);
        rootStore.emsStore.handleNotificationList(true);

        addNotification(message);
        if (title.indexOf("Flight:") !== -1) {
          console.log("Flight:", title);
          rootStore.emsStore.handleNotificationTitleandMeg({
            notificationTitle: title,
            notificationMessage: message
          });
          // setNotification(title);
          // setMessage(message);
        } else if (title.indexOf("Reported") !== -1) {
          console.log('inside Emergency Reported', title.indexOf("Emergency Reported"));
          rootStore.emsStore.handleNewEmergency();
          // handleNewEmergencyNotification(newEmergencyNotification + 1);
        } else if (title.indexOf('File Uploaded') !== -1) {
          console.log("Report Uploaded Notification");
          // handleNewReportNotification(report + 1);
          rootStore.emsStore.handleReport();
        } else if (title.indexOf("Chat notification") !== -1 || title.indexOf("Captain chat notification") !== -1) {
          console.log("Chat notification in condition", title);
        } else if (title.indexOf("landed") !== -1) {
          // handleNewReportNotification(report + 1);
          rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
        } else {
          console.log('No one condition matched');
        }
        //show(title + ";" + message);
      } // { type: 'message-from-sw', data: 'Hello from the service worker' }
    });
  }, [rootStore.errorHandlingStore.getShowError]);

  // const registerEndpoint = async () => {



  //   var endpointUrl = await localStorage.getItem("endpointUrl");
  //   var auth = await localStorage.getItem("auth");
  //   var p256dh = await localStorage.getItem("p256dh");
  //   var username= (await Auth.currentUserInfo()).username;
  //   console.log("registerEndPointParameter","/endpointUrl",endpointUrl,"/auth",auth,"/p256dh",p256dh,"/username",username);
  //   await EndpointService.registerEndpoint(endpointUrl, auth, p256dh,username);
  //   console.log("hasRegisterurl is updated successfully!")

  // };
  // const checkEndpointValue = async () => {
  //   var endpointUrl = await localStorage.getItem("endpointUrl");
  //     var auth = await localStorage.getItem("auth");
  //     var p256dh = await localStorage.getItem("p256dh");
  //     var username= (await Auth.currentUserInfo()).username;
  //     console.log("registerEndPointParameter","/endpointUrl",endpointUrl,"/auth",auth,"/p256dh",p256dh,"/username",username);
  // }
  async function addNotification(msg) {
    const audioElement = new Audio(notificationSound);
    audioElement.muted = true;
    audioElement.play().then(() => {
      audioElement.muted = false;
    });
    // let message = msg;
    // message = message.split(" ");
    // message.shift();
    // message = message.join(" ");
    // document.title = message;
    // setTimeout(() => {
    //   document.title = originalTitle;
    // },10000)
  }
  const theme = {
    global: {
      colors: {
        brand: StandardColors.primary_blue_100,
        "brand-1": StandardColors.primary_blue_100,
        "brand-2": "#204d97",
        "brand-3": StandardColors.secondary_blue_100,
        "brand-light": "#aecdfe",
        ...StandardColors,
      },
      font: {
        family: "Arial",
        size: "18px",
        height: "20px",
      },
      elevation: {
        light: {
          none: "none",
          // xsmall: "0px 1px 2px " + StandardColors.shadow,
          // small: "0px 2px 4px " + StandardColors.shadow,
          // medium: "0px 3px 8px " + StandardColors.shadow,
          // large: "0px 6px 12px " + StandardColors.shadow,
          // xlarge: "0px 8px 16px " + StandardColors.shadow,

          xsmall: "5px 0px 20px 4px " + StandardColors.new_shadow_color,
          small: "5px 0px 20px 4px " + StandardColors.new_shadow_color,
          medium: "5px 0px 20px 4px " + StandardColors.new_shadow_color,
          large: "5px 0px 20px 4px " + StandardColors.new_shadow_color,
          xlarge: "5px 0px 20px 4px " + StandardColors.new_shadow_color,
        },
      },
      dataTable: {
        pagination: {
          container: {
            pad: 'small',
            background: '#F4F8FE',
            round: 'small',
          },
          button: {
            color: 'green',
            hover: {
              background: 'yellow',
              color: 'red',
            },
            active: {
              background: 'brand',
              color: 'white',
            },
          },
          text: {
            color: 'text',
          },
        },
      },
      box: {
        extend: {
          minHeight: 'unset',  // Apply 'unset' to min-height for all Box components
        },
      },
    },
  };

  useEffect(() => {

    const persistedState = loadStateFromStorage();
    if (persistedState) {
      // Update your MobX store with the persisted state
      rootStore.userStore.setMultiLogin(persistedState);
    }
  }, []);

  useEffect(() => {
    saveStateToStorage(rootStore.userStore.getMultiLogin);
  }, [rootStore.userStore.getMultiLogin]);

  // useEffect(() => {
  //   (async function() {
  //     await CheckMultiLoginFun();
  //   })();
  // },[]);

  // Reset Password Handler
  const resetPasswordHandler = () => {
    Mixpanel.track("web_sidebar_reset_password_click", { name: user?.username });
    // navigate('iam/reset-password');
    navigate('/reset-password');
    // window.location.href = "/reset-password"
  }

  // Logout user
  const logoutClicked = async () => {
    Auth.signOut();
    localStorage.removeItem("endpointUrl");
    localStorage.removeItem("auth");
    localStorage.removeItem("p256dh");
    localStorage.removeItem("isRegister");
    localStorage.removeItem("registerEndPointError");
    if (user?.username) {
      Mixpanel.track("web_user_logout", { name: user?.username });
    }
    Mixpanel.resetUser();
    setUser(null);
    localStorage.clear();
    unsubscribeToTopic(rootStore);

    window.location.href = "/";
    // window.location.href = "";
    // navigate("", {
    //   replace: true,
    // });
    await EndpointService.removeRegisterEndpoint(user?.username);
    // window.location.reload();
  };

  const getMedical = async (medicalId) => {
    if (medicalId) {
      const medicalEmergencyFromAPI =
        await MedicalEmergencyService.getMedicalEmergency(medicalId);
      rootStore.emsStore.handleSelectedEmergency(medicalEmergencyFromAPI);
    }
  }

  let userInfo;
  useEffect(() => {
    (
      async () => {
        userInfo = localStorage.getItem("userinfo");
        let roleLabel = JSON.parse(userInfo).roleLabel;
        rootStore.emsStore.handleRoleLabel(roleLabel);
        if (roleLabel.toLowerCase() == "admin") {
          let username = JSON.parse(userInfo).username;
          let userOrg = await createuserService.getOrgByUserName(username);
          setOrgId(userOrg.id);
          rootStore.adminStore.handleSelectedOrgName(userOrg.name);
        }
      }
    )();
  }, [userInfo]);


  
//subscription


useEffect(() => {
  const fetchSubscription = async () => {
    try {
      const result = await SafeairManager.getSubscriptionByOrgId({
        api: APIs.Form.getSubscriptionByOrgId,
        parameters: { orgId },
      });

      console.log("Fetched subscription:", result);
      setSubscription(result);
    } catch (err) {
      console.error("Failed to fetch subscription:", err);

      const message = err?.response?.data?.errorMessage;

      if (
        err?.response?.status === 400 &&
        message?.includes("Subscription for this organization does not exist")
      ) {
        setSubscriptionError(true);
      }
    }
  };

  if (orgId) {
    fetchSubscription();
  }
}, [orgId]);

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("/");
  return `${day}/${month}/${year}`;
};

// Determine values to show
const startDate = subscription?.startDate ? formatDate(subscription.startDate) : "";
const endDate = subscription?.endDate ? formatDate(subscription.endDate) : "";
const status = subscription?.status || "";


// console.log ('status', status)

//subscription


  let ImageSrc = rootStore.userStore.getBellIconClick ? activeBell : inActiveBell;
  let ApplyClass = rootStore.userStore.getBellIconClick && rootStore.emsStore.getNotificationList ? "round-circle addBadge active" : rootStore.userStore.getBellIconClick ? "round-circle active" : rootStore.emsStore.getNotificationList ? "round-circle addBadge" : "round-circle";
  useEffect(() => {
    ImageSrc = rootStore.userStore.getBellIconClick ? activeBell : inActiveBell;
    ApplyClass = rootStore.userStore.getBellIconClick && rootStore.emsStore.getNotificationList ? "round-circle addBadge active" : rootStore.userStore.getBellIconClick ? "round-circle active" : rootStore.emsStore.getNotificationList ? "round-circle addBadge" : "round-circle";
  }, [rootStore.userStore.getBellIconClick, rootStore.emsStore.getNotificationList]);

  // function for bell icon click
  const onNotificationClick = () => {
    Mixpanel.track("web_sidebar_notification_click", { name: user?.username });
    rootStore.userStore.handleBellIconClick();
    rootStore.emsStore.handleNotificationList(false);
  }

  let notificationList;

  // Check if notifications exist in localStorage
  const notifications = localStorage.getItem("notificationlist");
  if (notifications) {
    //alert("sss");
    // Parse the stored notifications into an array
    const parsedNotifications = JSON.parse(notifications) ?? [];

    // Map over the array to create NotificationListItem components
    notificationList = parsedNotifications.map((notification) => (

      <NotificationListItem notification={notification} />
    ));
  } else {

    // If no notifications are found or localStorage is empty
    notificationList = (
      <NotificationListItem notification={""} />
    );
  }

  const handleProfileClick = () => {
    navigate(`/edit-profile?username=${user.username}`);
  };


  return (
    <Grommet theme={theme} style={{ background: StandardColors.background }}>
      <NotificationAlert
        onCancelOrDone={hide}
        showAlert={showInAppNotification}
        text={text.split(";")[0]}
        subText={text.split(";")[1]}
      />
      <NotificationToast />
      <SuccessMsg />
      <CallNotification />
      <ResponsiveContext.Consumer>
        {(size) => {
          //size of screen (Mobile, PC ?)
          return (
            <div id="app_main" style={{ padding: !pathname.includes("/call") && !pathname.includes("/audiocall") ? "10px 20px 20px" : "0" }}>
              {/* Header */}
              {rootStore.sidebarStore.getShowSidebar && (size === "small" || size == "xsmall") && (
                <Header />
              )}
              <div style={{ margin: "0 -10px" }}>
                {
                  (pathname.indexOf("/call") == -1 && pathname.indexOf("audiocall") == -1)
                  &&
                  <Box className="common-info">
                    <Box className="user-card-main">
                      <img src={skali_logo} />
                      <Box className="user-card">
                        <Text className="user-info user-name">{user ? `${user?.name} ${user?.family_name}` : ""}</Text>
                        <Text className="user-info user-info-sec">{user ? `${user.roleLabel.toUpperCase()}  |  @${user?.username
                          }` : ""}</Text>
                        <Text style={{ backgroundColor: rootStore.emsStore.getNetworkValue ? '#84E6B1' : "red" }} className="network-indicator"></Text>
                      </Box>
                      {
                        user && user.roleLabel.toLowerCase() == "admin"
                          ?
                          (<Box className="user-card" style={{ marginLeft: 10 }}>
                            <Text className="user-info user-info-sec ml-0">{rootStore.adminStore.getSelectedOrgName || "Organization"}</Text>
                          </Box>)
                          :
                          (null)
                      }
                    </Box>
                    <Box className="right-container">
                    
                    <Text className="logout-text" style={{ marginRight: 10 }}>
                        {`${localTime} (${new Date().toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ')[2]})`}
                      </Text>

                    <Text className="logout-text" style={{ marginRight: 10 }}>
                        {/* You can use the AnalogClock component here */}
                        <AnalogClock />
                      </Text>
                      
                      <Text className="logout-text" style={{ marginRight: 10 }}>
                        {temperature ? `${temperature}°F` : ''}
                      </Text>

                      <Text onClick={resetPasswordHandler} className="logout-text">
                        Reset Password
                      </Text>

                      <Text className="divide-line">
                      </Text>
                      <Box className="header-notification-container">
                        <Box onClick={onNotificationClick} className={ApplyClass}>
                          <img src={ImageSrc} />
                        </Box>
                        {
                          rootStore.userStore.getBellIconClick && localStorage.getItem("notificationlist")
                            ?
                            <div className="notification-list-container">
                              <ul className="notification-list">
                                {notificationList}
                              </ul>
                            </div>
                            : rootStore.userStore.getBellIconClick
                              ?
                              <div className="notification-list-container">
                                <div className="no-notification-txt">
                                  <span>Notification Not Found.</span>
                                </div>
                              </div>
                              :
                              null
                        }
                      </Box>
                      <Text className="divide-line"></Text>
                      <div className="profile-container" onClick={handleProfileClick}>
  {user?.roleLabel?.toLowerCase() === "admin" &&
    (status === "ACTIVE" || status === "RENEWED") && (
      <div className="crown-wrapper">
        <img src={crown} alt="crown" className="crown-icon" />
      </div>
  )}

  <div className="user-profile">
    <div className="profile-image-wrapper">
      <img src={imageSrc} alt="profile image" className="profile-image" />
    </div>
  </div>
</div>


                      <Text className="divide-line"></Text>
                      <Box className="logout-outer">
                        <Link onClick={logoutClicked} className="logout-image"><img src={logoutIcon} /></Link>
                        <div className="tooltip">
                          <Text className="tooltipTxt">Log Out</Text>
                        </div>
                      </Box>
                    </Box>
                  </Box>
                }
              </div>
              {/*  Sidebar Menu */}
              {rootStore.sidebarStore.getShowSidebar && (size === "medium" || size === "large") && (
                <Box
                  height="100%"
                  align="center"
                  justify="start"
                  style={{ marginLeft: 30, marginRight: 30 }}
                >
                  <Sidebar />
                </Box>
              )}
              {/* Main View */}
              <Box
                direction="row"
                flex
                overflow={{ horizontal: pathname.indexOf("/audiocall") == -1 ? "hidden" : "visible" }}
                className="grommet-main"
                align="stretch"
                style={{ marginTop: pathname.indexOf("/call") === -1 && pathname.indexOf("/audiocall") === -1 ? 12 : 0 }}
              >
                {/* App Body */}
                <Box
                  // style={
                  //   rootStore.sidebarStore.getShowSidebar && (size === "medium" || size === "large")
                  //     ? { marginLeft: "130px" }
                  //     : { marginLeft: "0px" }
                  // }
                  flex
                >
                  <Body currentRoutePath={pathname} />
                </Box>
              </Box>
              {/* </Router> */}
              {rootStore.errorHandlingStore.getShowError ? (
                <ErrorDialog />
              ) : (
                <></>
              )}
            </div>
          );
        }}
      </ResponsiveContext.Consumer>
      {rootStore.loadingStore.getShowLoader && <SpinnerLoader />}
      <div className="browser-notification-container">
        <NotificationContainer />
      </div>
    </Grommet>
  );
});

export default Main;


const NotificationListItem = ({ notification }) => {
  const navigate = useNavigate();

  const { rootStore } = useStore();

  function ChooseIcon(iconName) {
    switch (iconName) {
      case "Chat notification":
        return chatNotification
      default:
        return notificationMessage
    }
  }

  const onChatNotificationClick = (incidentId) => {
    const navigationPath = "ems/medical-emergencies/emergency/" + incidentId;
    navigate(navigationPath);
  }

  const getMedical = async (medicalId) => {
    if (medicalId) {
      const medicalEmergencyFromAPI =
        await MedicalEmergencyService.getMedicalEmergency(medicalId);
      rootStore.emsStore.handleSelectedEmergency(medicalEmergencyFromAPI);
    }
  }
  console.log("+++ notification.title +++", notification.title);
  return (
    <li style={{ cursor: ((typeof (notification.title) == "string" && notification.title.toLowerCase().indexOf("joined videocall") !== -1) || (typeof (notification.title) == "string" && notification.title.toLowerCase().indexOf("chat notification") !== -1)) ? 'pointer' : 'default' }} onClick={() => {
      if (notification.title.toLowerCase().includes("joined videocall")) {
        handleVideoNotificationClick(notification.title, notification.eventId, notification.flightId, getMedical, rootStore);
      } else if (notification.title.toLowerCase().includes("chat notification" || notification.eventId != "" || notification.eventId != null)) {
        onChatNotificationClick(notification.eventId);
      } else {

      }
    }}>
      <div className="notification-item-content">
        <div className="notification-image">
          <img src={ChooseIcon(notification.title)} alt={notification.title} />
        </div>
        <div className="notification-details">
          <div className="notification-item-title">{notification.title}</div>
          <div className="notification-item-message">{notification.message}</div>
          <div className="notification-item-time">{Utility.timelog(notification.time)}</div>
        </div>
      </div>
    </li>
  )
}